{
	"close": "Loka",
	"number-of-results": "Fjöldi niðurstaða:",
	"search": "Leita",
	"search-here": "Leitaðu hér",
	"search-no-results": "Leitin skilaði engum niðurstöðum.",
	"search-placeholder-long": "Leitaðu eftir pósthúsum, póstboxum, eyðublöðum, almennu efni",
	"search-results": "Leitarniðurstöður",
	"see-all-results-for": "Sjá allar leitarniðurstöður fyrir "
}
